/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateArticlePastSearchAutoRenew
 */
export interface UpdateArticlePastSearchAutoRenew {
    /**
     * 自動更新するかどうか
     * @type {boolean}
     * @memberof UpdateArticlePastSearchAutoRenew
     */
    isAutoRenewed: boolean;
}

export function UpdateArticlePastSearchAutoRenewFromJSON(json: any): UpdateArticlePastSearchAutoRenew {
    return UpdateArticlePastSearchAutoRenewFromJSONTyped(json, false);
}

export function UpdateArticlePastSearchAutoRenewFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateArticlePastSearchAutoRenew {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAutoRenewed': json['is_auto_renewed'],
    };
}

export function UpdateArticlePastSearchAutoRenewToJSON(value?: UpdateArticlePastSearchAutoRenew | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_auto_renewed': value.isAutoRenewed,
    };
}

